import Service from '@ember/service';

import { tracked } from '@glimmer/tracking';

import searchConfig from 'rise-ui/config/search.js';
import { refreshes } from 'rise-ui/utils/query-params.js';
import { softSet } from 'rise-ui/utils/object.js';

export const qp = {
  search: 'search',
  topic: 'topic',
};

export const qpRoute = {
  search: refreshes(qp.search),
  topic: refreshes(qp.topic),
};

export const queryParamKeys = Object.keys(qp);
export const queryParams = Object.values(qp);

export const helpSearchRouteQueryParams
  = queryParamKeys.reduce((params, key) => {
  return { ...params, ...qpRoute[key] };
}, {});

export const wordsToExcludeFromTerms = new Set(searchConfig.termsToExclude);

export const topics = {
  topic2: 'Catalog',
  topic3: 'Time Series Query',
  topic4: 'Map Interface',
  // topic5: 'Data Visualization',
  topic7: 'FAQs',
  topic8: 'RISE API',
  topic9: 'Download API',
};

export default class HelpSearchService extends Service {
  @tracked search = '';
  @tracked terms = [];
  @tracked results;
  @tracked topic;
  @tracked topicName;
  topics = topics;

  setParams(params = {}) {
    for (let p in params) {
      switch (p) {

        case 'search': {
          const search = params[p] || '';
          softSet(this, 'search', search);
          softSet(this, 'terms',
            search.split(' ')
              .filter(word => word && !wordsToExcludeFromTerms.has(word))
          );
        } break;

        case 'topic': {
          const topic = params[p];
          softSet(this, 'topic', topic);
          softSet(this, 'topicName', topics[topic]);
        } break;

      }
    }
  }

  setResults(results) {
    this.results = results;
  }
}
